import type { HydrationError } from "@app/helpers/hydrate-errors";
import type { SentryOptions } from "@app/services/sentry-facade";

export async function lazyReportHydrateErrorsToSentry(
  error_title: string,
  hydration_error: HydrationError,
  tags: SentryOptions["tags"]
): Promise<void> {
  const { SentryFacade } = await import("../services/sentry-facade");
  const { reportHydrateErrorsToSentry } = await import("./hydrate-errors");
  reportHydrateErrorsToSentry(SentryFacade, error_title, hydration_error, tags);
}
